<template>
	<v-chip
		:class="{ active }"
		:color="mColor.base"
		:text-color="mColor.base"
		:style="{ '--bg': mColor.bg, '--base': mColor.base }"
		link
		outlined
		class="selectable-chip"
	>
		<v-avatar left size="18" :color="mColor.base" />
		<base-text small :style="{ color: `${mColor.base} !important` }">
			<slot></slot>
		</base-text>
	</v-chip>
</template>

<script>
export default {
	name: 'SelectableChip',
	props: {
		active: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'green',
		},
	},
	data: () => ({
		colors: {
			green: {
				bg: '#E7FCED',
				base: '#088913',
			},
			yellow: {
				bg: '#FEF8EC',
				base: '#F2C766',
			},
			red: {
				bg: '#FDE0D5',
				base: '#AC2F00',
			},
		},
	}),
	computed: {
		mColor() {
			return this.colors[this.color] || this.colors.green
		},
	},
}
</script>

<style lang="scss">
.v-chip {
	&.selectable-chip {
		height: 28px !important;
		&.v-chip--outlined.active {
			background-color: var(--bg) !important;
		}
		.v-avatar {
			width: 18px !important;
			min-width: 18px !important;
			height: 18px !important;
		}
	}
}
</style>
